import { Button } from '@portals/core/src/components/Button/Button';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';

import { Close } from '../utils/loadIcon';

export function usePreviewSnack(preview: boolean, publicationState: string, slugPath: string): void {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (preview) {
      enqueueSnackbar(`${publicationState}-mode`, {
        action: (
          <Button
            variant="inverted"
            size="small"
            href={`/api/internal/preview/clear?slug=${slugPath}`}
            endIcon={<Close />}
          />
        ),
        persist: true,
        preventDuplicate: true,
      });
    }
  }, [publicationState, preview, enqueueSnackbar, slugPath]);
}
